{
	"aiStyleCreatedMessage": "{{name}} has been successfully created.",
	"aiStyleCreatedTitle": "Your AI Style has been created!",
	"aiStyleProcessingMessage": "Your AI Style is now processing your photos, and it will make some mistakes due to the limited number of References Edits it saw so far. While the AI is processing, you can fine-tune the AI result and mark additional Reference Edits until your entire album looks consistent in colors.",
	"aiStyleProcessingTitle": "Your AI Style gets smarter overtime.",
	"aiStyleUpdatedMessage": "Congrats! Your AI Style just got closer to your signature look. Continue to add more edits in future projects to make it even better.",
	"aiStyleUpdatedTitle": "Your AI Style has been updated",
	"createReferenceEditTitle": "Create your first Reference Edit",
	"failedUpdateMessage": "{{name}} has failed to update. Please try again later.",
	"failedUpdateTitle": "Failed to Update AI Style",
	"nameStyleButton": "Name Style",
	"nameYourAiStyle": "Name your AI Style",
	"newStyleIncludesReferences": "The newly created AI Style will include all References from this project.",
	"saveStyleButton": "Save Style"
}
